export const PDT_TEMPLATE_ID = '25821';

export const PDT_PAGENAMES = {
  LISTING: 'listing',
  DETAILS: 'details',
  REVIEW: 'review',
};
export const PDT_PAGETYPE = {
  FUNNEL: 'funnel',
  LANDING: 'landing',
  TEMPLATE: 'template',
};

export const PDT_PAGEVERSIONS = {
  V1: 'V1',
  V2: 'V2',
  V3: 'V3',
};
export const PDT_FUNNELTYPES = {
  HOLIDAYS: 'Holidays',
};
export const PDT_SUBPAGENAMES = {
  DETAILS_GALLERY: 'gallery',
  FLIGHT_LISTING: 'flight_listing',
  ACTIVITY_DETAIL: 'activity_detail',
  ACTIVITY_GALLERY: 'activity_gallery',
  ACTIVITY_RATEPLAN: 'activity_rateplan',
  HOTEL_DETAIL: 'hotel_detail',
  HOTEL_GALLERY: 'hotel_gallery',
  HOTEL_RATINGS: 'hotel_reviews_ratings',
  HOTEL_LOCATION: 'hotel_map',
  HOTEL_RULES: 'hotel_rules',
  HOTEL_RATING_REVIEW: 'hotel_reviews_ratings',
  INSURANCE_DETAIL: 'insurance_detail',
};
